import React from "react";
import PropTypes from "prop-types";
import MarkdownTimeline from "./MarkdownTimeline";
import useChatStreamListener from "@web/hooks/useChatStreamListener";
import ChatProgressData from "@web/ui/containers/ChatProgressData";
// import DraftEditorManager from "./DraftEditorManager";
import {useDispatch, useSelector} from "react-redux";
import {chatAppAgentIds} from "@oven/app-thescribe/src/dashboard.config";
// import UserTaskProgressManager from "./UserTaskProgressManager";
import {Avatar, Card, Col, Comment, Row} from 'antd';
import {FeatherIcon} from "@web/assets/icons";
// import aiActions from "@web/redux/ai/actions";
// import StreamingDraftListener from "./StreamingDraftListener";
import ChatPrompt from "./ChatPrompt";
import ActiveWorkflowCard from "./ActiveWorkflowCard";
import ChatItem from "./ChatItem";
import ItemData from '@web/ui/containers/ItemData';
import AppListingCard from './AppListingCard';
import {LinesContext} from '@web/hooks/context';

ChatFeedback.propTypes = {
  promptText: PropTypes.string,
  onAddContextPath: PropTypes.func,
  onRemoveContextPath: PropTypes.func,
  chat: PropTypes.object,
  path: PropTypes.string,
  hidePrompt: PropTypes.bool,
  hideProgress: PropTypes.bool,
};

function ChatFeedback(props) {
  // const dispatch = useDispatch();
  const ctx = React.useContext(LinesContext);
  // const activeServiceId = useSelector((state) => state.App.activeServiceId);
  // const activeDraftPath = useSelector((state) => state.AI?.[activeServiceId]?.draft?.draftPath);
  const activeUserTaskPath = useSelector((state) => state.AI?.[ctx.collectionId]?.userTask?.path);
  const activeAppPath = useSelector((state) => state.AI?.[ctx.collectionId]?.activeApp?.path);
  const [chatStream, chatPath,] = useChatStreamListener();
  const [collapsed, setCollapsed] = React.useState(false);

  React.useEffect(() => {
    setCollapsed(false);
  }, [props.promptText]);

  const toggleCollapse = React.useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);

  // const onClearEmailDraft = React.useCallback(() => {
  //   dispatch(aiActions.clearActiveEmailDraft());
  // }, [dispatch]);

  // const onClearTask = React.useCallback(() => {
  //   dispatch(aiActions.clearActiveUserTask());
  // }, [dispatch]);
  //
  // const onClearApp = React.useCallback(() => {
  //   dispatch(aiActions.clearActiveApp());
  // }, [dispatch]);

  return <div className="chat-feedback-view">
    <Row className="w-full">
      <Col xs={24} sm={24} md={24} lg={23} xl={23} xxl={23} className="overscroll-contain">
        {(props.promptText || chatStream?.prompt?.text) &&
          !props.hidePrompt &&
          <ChatPrompt
            chat={chatStream}
            onClick={toggleCollapse}
            primary
            collapsed={collapsed}
          />
        }
        {!collapsed &&
          chatStream?.answers?.length ?
          <section className="space space-end-y" style={{paddingLeft: 20}}>
            <div className="space space-col">
              <Comment
                author={props.chat?.prompt?.agentId || chatStream?.prompt?.agentId}
                avatar={
                <Avatar
                  icon={<FeatherIcon className="gold-icon" style={{position: 'relative', top: 4}} />}
                  size="large"
                />
                }
                content={
                  chatStream.answers.map((answer) =>
                    !!answer.text &&
                    !!answer.toolCalls &&
                    !chatAppAgentIds.includes(answer.agentId) &&
                    <MarkdownTimeline
                      key={answer.generated}
                      markdown={answer.text}
                    />)
                }
              />
            </div>
          </section> :
          props.chat ?
            <ChatItem chat={props.chat} chatIndex={0} /> :
            null
        }
          {!!activeUserTaskPath &&
            <div style={{width: '990px', maxWidth: '100%', marginBottom: '10px'}}>
              {/*<UserTaskProgressManager*/}
              {/*  collapsed={true}*/}
              {/*  path={activeUserTaskPath}*/}
              {/*  onAddContextPath={props.onAddContextPath}*/}
              {/*  onRemoveContextPath={props.onRemoveContextPath}*/}
              {/*  onClearTask={onClearTask}*/}
              {/*  onClearEmailDraft={onClearEmailDraft}*/}
              {/*/>*/}
            </div>
          }
          {!!activeAppPath &&
            <div style={{width: '990px', maxWidth: '100%', marginBottom: '0'}}>
              {activeAppPath.includes("/app-store/") ?
                <ItemData dataField="app" collapsed path={activeAppPath} component={AppListingCard} onAddContextPath={props.onAddContextPath} onRemoveContextPath={props.onRemoveContextPath} /> :
                <ItemData dataField="workflow" collapsed path={activeAppPath} component={ActiveWorkflowCard} onAddContextPath={props.onAddContextPath} onRemoveContextPath={props.onRemoveContextPath} />
                // <ActiveWorkflowCard collapsed={true} path={activeAppPath} onAddContextPath={props.onAddContextPath} onRemoveContextPath={props.onRemoveContextPath} />
              }
            </div>
          }
          {!!chatPath && !props.hideProgress &&
            <ChatProgressData path={chatPath} />}
      </Col>
    </Row>
    {props.children}
  </div>
}

export default ChatFeedback;
